import { Overrides } from '@material-ui/core/styles/overrides';

export const initializeListOverrides = (config?: Overrides['MuiList']): Overrides['MuiList'] => {
  return {
    root: {
      // A tooltip wrapper that takes focus in place of its list item shows focus by tinting that item instead
      '& > [role="option"]:focus-visible': {
        outline: 'none',
      },
    },
    padding: {},
    ...config,
  };
};
